import { render, staticRenderFns } from "./FileDragFrame.vue?vue&type=template&id=50da6b5e&scoped=true"
import script from "./FileDragFrame.vue?vue&type=script&lang=js"
export * from "./FileDragFrame.vue?vue&type=script&lang=js"
import style0 from "./FileDragFrame.vue?vue&type=style&index=0&id=50da6b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50da6b5e",
  null
  
)

export default component.exports